import { styled } from "@bvhi/ui-base";
import { Outlet } from "@tanstack/react-router";
import { Suspense } from "react";
import { BVHIAppBar } from "../../../components/bvhi-app-bar";
import { BVHIBounceLoader } from "../../../components/bvhi-bounce-loader";
import { BVHIDrawer } from "../../../components/bvhi-drawer";
import { BVHIFooter } from "../../../components/bvhi-footer";
import { MUI_DRAWER_WIDTH } from "../../../config/constants";
import { DocsNavigationConfig } from "../../../config/navigation";

const GridContainer = styled("div")({
  height: "100svh",
  width: "100svw",
  maxWidth: "100%",
  display: "grid",
  overflowX: "hidden",
  gridTemplateColumns: `${MUI_DRAWER_WIDTH}px 1fr`,
  gridTemplateRows: "64px 1fr 64px",
  gridTemplateAreas: `"appbar appbar" "drawer main" "footer footer"`,
  alignItems: "stretch",
  justifyItems: "stretch",
  alignContent: "stretch",
  justifyContent: "stretch",
});

const GridAppbarItem = styled("div")({
  gridArea: "appbar",
});

const GridDrawerItem = styled("div")(() => ({
  display: "flex",
  gridArea: "drawer",
}));

const GridMainItem = styled("div")(({ theme }) => ({
  gridArea: "main",
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(2),
  paddingBottom: theme.spacing(2),
}));

const GridFooterItem = styled("div")({
  gridArea: "footer",
});

export const IndexView = () => {
  return (
    <GridContainer>
      <GridAppbarItem>
        <BVHIAppBar />
      </GridAppbarItem>
      <GridDrawerItem>
        <BVHIDrawer navigationConfig={DocsNavigationConfig} />
      </GridDrawerItem>
      <GridMainItem>
        <Suspense fallback={<BVHIBounceLoader />}>
          <Outlet />
        </Suspense>
      </GridMainItem>
      <GridFooterItem>
        <BVHIFooter navigationConfig={DocsNavigationConfig} />
      </GridFooterItem>
    </GridContainer>
  );
};
